import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=a61d707a&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a61d707a')) {
      api.createRecord('a61d707a', component.options)
    } else {
      api.reload('a61d707a', component.options)
    }
    module.hot.accept("./LoadingOverlay.vue?vue&type=template&id=a61d707a&", function () {
      api.rerender('a61d707a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay/LoadingOverlay.vue"
export default component.exports